import { t } from "@/i18n-js/instance";
import { planFeatures } from "@/react/helpers/plansHelpers";
import { FeatureCell } from "./FeatureCell";
import { NumberFeature } from "./NumberFeature";
import { StringFeature } from "./StringFeature";
import { TooltipIcon } from "./TooltipIcon";

interface PlanFeatureProps {
  feature: string;
  plan: any; // [TODO][BillingReactification][AfterRelease] Use actual PlanData
}

export const PlanFeature = ({ plan, feature }: PlanFeatureProps) => {
  const planValue = plan.plan_feature_flags[feature];
  const legacyLimitInfo = plan.legacy_limits_info[feature];
  const isHigherLimit = legacyLimitInfo && legacyLimitInfo.is_legacy_limit;
  const currentPlanValue = legacyLimitInfo?.current_plan_value;
  const resource: string = t(`settings.billing.${feature}`);
  const hasUnlimitedMembers =
    feature === planFeatures.max_member_count && plan.unlimited_members;

  return (
    <FeatureCell>
      {hasUnlimitedMembers ? (
        <>
          <StringFeature value={t("settings.billing.unlimited")} />
          <TooltipIcon
            tooltipKey="settings.billing.unlimited_members_tooltip"
            tooltipProps={{ total: currentPlanValue, resource }}
          />
        </>
      ) : (
        <NumberFeature value={planValue} />
      )}
      {isHigherLimit && (
        <TooltipIcon
          tooltipKey="settings.billing.legacy_limits_tooltip"
          tooltipProps={{ total: currentPlanValue, resource }}
        />
      )}
    </FeatureCell>
  );
};
